import React from 'react'
import Dashboardview from '../../components/dashboard/dashboardview'

export default function Dashboard() {
  return (
    <div className='px-4'>
        <Dashboardview/>
    </div>
  )
}
